import React from 'react';
import PropTypes from 'prop-types';

import { ThemeProvider } from '@material-ui/styles';
import { DatePicker as MaterialDatePicker } from '@material-ui/pickers';
import { InputAdornment } from '@material-ui/core';

import { FaSortDown } from 'react-icons/fa';

import { themePicker } from './theme';

function DatePicker({
  inputVariant = 'outlined',
  autoOk = true,
  format = 'dd/MM/yyyy',
  okLabel = 'Ok',
  cancelLabel = 'Cancelar',
  clearLabel = 'Limpar',
  todayLabel = 'Hoje',
  invalidDateMessage = 'Data inválida',
  ...props
}) {
  return (
    <ThemeProvider theme={themePicker}>
      <MaterialDatePicker
        inputVariant={inputVariant}
        autoOk={autoOk}
        format={format}
        okLabel={okLabel}
        cancelLabel={cancelLabel}
        clearLabel={clearLabel}
        todayLabel={todayLabel}
        invalidDateMessage={invalidDateMessage}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <FaSortDown />
            </InputAdornment>
          ),
        }}
        data-testid="material-datepicker"
        {...props}
      />
    </ThemeProvider>
  );
}

DatePicker.propTypes = {
  inputVariant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  format: PropTypes.string,
  autoOk: PropTypes.bool,
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  clearLabel: PropTypes.string,
  todayLabel: PropTypes.string,
  invalidDateMessage: PropTypes.string,
};

export { DatePicker };
